import { useContext, useEffect, useState } from 'react'
import EditProfileblm from './EditProfileblm';
import Blmpostadd from './Blmpostadd';
// import Viewersengagement from './Viewersengagement';
import Upgradeprofile from './Upgradeprofile';
import Contactdetaiilsprofile from './Contactdetaiilsprofile';
import Allpostownpage from './Allpostownpage';
import Allpostpage from './Allpostpage';
import { useDispatch, useSelector } from "react-redux";
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import { Link } from 'react-router-dom';
import cross from '../../Images/crosssimgiocn.png'
import BusinessPostModal from '../../Modal/BusinessPostModal';
import { fetchPageEnquiries } from '../../Redux/Slice/EnquirySlice';

const Ownpostpage = () => {
    const { UserProfileID } = useSelector((state) => state.app);
    const { PageEnquiries, PostEnquiries } = useSelector((state) => state.enquiry);
    const colordata = useContext(Colorcontext);
    const [tabpostall, setTabpostall] = useState(1)
    const dispatch = useDispatch();
    const { status, AllBusinessPosts } = useSelector((state) => state.post);
    const [allPostCount, setAllPostCount] = useState(0)
    const [myPostCount, setMyPostCount] = useState(0)

    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    useEffect(() => {
        const allPosts = AllBusinessPosts.filter(item => item.userData._id !== UserProfileID?._id)
        const myPosts = AllBusinessPosts.filter(item => item.userData._id === UserProfileID?._id)
        setAllPostCount(allPosts?.length || 0);
        setMyPostCount(myPosts?.length || 0);
    }, [AllBusinessPosts])

    useSelector((state) => state.app);

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const postdicclickbtn = (tabnumber) => {
        setTabpostall(tabnumber)
    }

    const [ownpostupdatemodal, setownpostupdatemodal] = useState(false)
    const ownnsposyymodal = () => {
        setownpostupdatemodal(!ownpostupdatemodal)
    }

    useEffect(() => {
        if (UserProfileID) {
            dispatch(fetchPageEnquiries())
            // dispatch(fetchPostEnquiries())
        }
    }, [])

    return (
        <section className='ownblmprofiledivmaoin'>
            <div className='cust_container'>
                <div className='ownblmprofiledivflx'>
                    {
                        isMobile ?
                            <>
                                <div className='ownblmprofiledivright'>
                                    <div className='allpostmyapooskducvsdic'>
                                        <div className='allpostmyapooskducvsdictop' style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            rowGap: '10px',
                                            paddingTop: '40px',
                                            position: 'relative'
                                        }}>
                                            <div className='postamtydposdivflx'>
                                                <button className={tabpostall === 1 ? "poisttsdpostdibbtn actv " : "poisttsdpostdibbtn"} onClick={() => postdicclickbtn(1)}>Updates ({allPostCount})</button>
                                                <button className={tabpostall === 2 ? "poisttsdpostdibbtn actv " : "poisttsdpostdibbtn"} onClick={() => postdicclickbtn(2)}>My Post ({myPostCount})</button>
                                            </div>

                                            <Link
                                                to={`/businesspage/${UserProfileID?.companySlug}`}
                                                className="ocensttxttpppp _profileLink"
                                            >
                                                <img src={cross} style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    width: '15.5px',
                                                    cursor: 'pointer'
                                                }} />
                                            </Link>
                                            <button
                                                className='poisyybtnmain'
                                                onClick={ownnsposyymodal}
                                                disabled={!UserProfileID?.businessStatus}
                                            >
                                                Post
                                                <i className="fa-solid fa-plus"></i>
                                            </button>
                                        </div>
                                        <div className='allpostmyapooskducvsdicbottom'>
                                            {tabpostall === 1 && (
                                                <>
                                                    <Allpostpage />
                                                </>
                                            )}
                                            {tabpostall === 2 && (
                                                <>
                                                    <Allpostownpage />
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className='ownblmprofiledivleft'>
                                    <div className='repsonsivedivcls'>
                                        {/* For mobile responsive code start  */}
                                        <div className=' oenblmsnfidivmainleft'>
                                            <div style={{
                                                marginTop: '10px'
                                            }} className='oenblmsnfdrpbapbbtm responsivdedivmain '>
                                                <Upgradeprofile />
                                            </div>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain'>
                                                {/* <EditProfileblm /> */}
                                                <EditProfileblm data={UserProfileID} />
                                            </div>
                                        </div>

                                        <div className='oenblmsnfidivmainright'>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain'>
                                                <Contactdetaiilsprofile data={UserProfileID} />
                                            </div>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain '>
                                                <Blmpostadd />
                                            </div>
                                        </div>
                                        {/* For mobile responsive code  end */}
                                    </div>


                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        {/* <EditProfileblm /> */}
                                        <EditProfileblm data={UserProfileID} />
                                    </div>

                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Blmpostadd />
                                    </div>

                                    <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                                        <div className='bmlmmaposttaddddib'>
                                            <div className='bmlmmaposttaddddibdivmain'>
                                                <div className='poisyybtnmainlibkldivflx'>
                                                    <Link className="_direxrrcttstbtn ipyysffraedtn"
                                                        style={{
                                                            margin: "0 auto",
                                                            color: "#fff"
                                                        }}
                                                        to="/myenquiries"
                                                    >
                                                        View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Upgradeprofile />
                                    </div>
                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Contactdetaiilsprofile
                                            data={UserProfileID}
                                        />
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className='ownblmprofiledivleft'>
                                    <div className='repsonsivedivcls'>
                                        {/* For mobile responsive code start  */}
                                        <div className=' oenblmsnfidivmainleft'>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain'>
                                                {/* <EditProfileblm /> */}
                                                <EditProfileblm data={UserProfileID} />
                                            </div>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain '>
                                                <Upgradeprofile />
                                            </div>
                                        </div>
                                        <div className='oenblmsnfidivmainright'>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain'>
                                                <Contactdetaiilsprofile data={UserProfileID} />
                                            </div>
                                            <div className='oenblmsnfdrpbapbbtm responsivdedivmain '>
                                                <Blmpostadd />
                                            </div>
                                        </div>
                                        {/* For mobile responsive code  end */}
                                    </div>


                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        {/* <EditProfileblm /> */}
                                        <EditProfileblm data={UserProfileID} />
                                    </div>

                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Blmpostadd />
                                    </div>

                                    <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                                        <div className='bmlmmaposttaddddib'>
                                            <div className='bmlmmaposttaddddibdivmain'>
                                                <div className='poisyybtnmainlibkldivflx'>
                                                    <Link className="_direxrrcttstbtn ipyysffraedtn"
                                                        style={{
                                                            margin: "0 auto",
                                                            color: "#fff"
                                                        }}
                                                        to="/myenquiries"
                                                    >
                                                        View Enquiries ({PageEnquiries?.length + PostEnquiries?.length})
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Upgradeprofile />
                                    </div>

                                    <div className='oenblmsnfdrpbapbbtm deslrtopwdijjsmain'>
                                        <Contactdetaiilsprofile
                                            data={UserProfileID}
                                        />
                                    </div>
                                </div>

                                {/* Displaying Posts */}
                                <div className='ownblmprofiledivright'>
                                    <div className='allpostmyapooskducvsdic'>
                                        <div className='allpostmyapooskducvsdictop' style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            position: 'relative',
                                            paddingTop: '40px'
                                        }}>
                                            <div className='postamtydposdivflx'>
                                                <button className={tabpostall === 1 ? "poisttsdpostdibbtn actv " : "poisttsdpostdibbtn"} onClick={() => postdicclickbtn(1)}>Updates ({allPostCount})</button>
                                                <button className={tabpostall === 2 ? "poisttsdpostdibbtn actv " : "poisttsdpostdibbtn"} onClick={() => postdicclickbtn(2)}>My Post ({myPostCount})</button>

                                            </div>
                                            {/* <img src={cross} style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                width: '15.5px',
                                                cursor: 'pointer'
                                            }} /> */}

                                            {/* <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                columnGap: "8px",
                                                fontSize: '16px',
                                                color: '#fff',
                                                background: '#09974b',
                                                width: 'fit-content',
                                                padding: '8px 30px',
                                                borderRadius: '8px',
                                                fontWeight: '500'
                                            }}>Post <i class="fa-solid fa-plus"></i>
                                            </div> */}

                                            <button
                                                className='poisyybtnmain'
                                                onClick={ownnsposyymodal}
                                                disabled={!UserProfileID?.businessStatus}
                                            >
                                                Post
                                                <i className="fa-solid fa-plus"></i>
                                            </button>

                                        </div>
                                        <div className='allpostmyapooskducvsdicbottom'>
                                            {tabpostall === 1 && (
                                                <>
                                                    <Allpostpage />
                                                </>
                                            )}
                                            {tabpostall === 2 && (
                                                <>
                                                    <Allpostownpage />
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </>
                    }
                </div>
            </div>
            {ownpostupdatemodal && <BusinessPostModal closemodal={setownpostupdatemodal} />}
        </section>
    )
}

export default Ownpostpage
